import { z } from "zod";
import {
  emailField,
  optionalString,
  requiredString,
  zipCodeField,
} from "@smeetz/services-validation";

export interface CustomerCreateValues {
  title: string;
  firstName: string;
  lastName: string;
  email: string;
  language: string | number;
  birthDate: string;
  allergies: string;
  address: string;
  zipCode: string;
  city: string;
  country: string;
  phone: string;
  company: string;
  emailMarketingOrganiser: string | number;
}

/**
 * Zod schema for the customer create form.
 *
 * @returns {z.ZodType<CustomerCreateValues>} schema validating the customer fields.
 */
export function customerCreateSchema() {
  return z.object({
    title: optionalString(),
    firstName: requiredString({ max: 45 }),
    lastName: requiredString({ max: 45 }),
    email: emailField({ max: 255 }),
    language: z.union([z.string(), z.number()]).optional(),
    birthDate: optionalString(),
    allergies: optionalString(),
    address: optionalString(),
    zipCode: zipCodeField({ optional: true, max: 30 }),
    city: optionalString({ max: 50 }),
    country: optionalString(),
    phone: optionalString(),
    company: optionalString({ max: 50 }),
    emailMarketingOrganiser: z.union([z.string(), z.number()]),
  });
}
